const Doshas = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {
    /* Mobile Layout (sm:flex) */
  }
                <div className="mx-auto max-w-7xl lg:hidden">
                    <div className="flex flex-col gap-8">
                        {
    /* Header */
  }
                        <div>
                            <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                                Verständnis der Lebensenergie
                            </p>
                            <h2 className="mt-5 font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                                Doshas – Die Energie, die das Leben steuert
                            </h2>
                        </div>

                        {
    /* Image */
  }
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-[#f3eee7] shadow-[0_24px_70px_rgba(16,38,26,0.14)]">
                            <img
    src="/images/Hiru/kapha-pitta-vata.webp"
    alt="Die Doshas Vata, Pitta und Kapha"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/55 via-transparent to-transparent" />
                        </div>

                        {
    /* Content */
  }
                        <div>
                            <div className="space-y-8 font-mulish text-base leading-8 text-gray-700">
                                <div>
                                    <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c]">
                                        Reise mit einer persönlichen Diagnose
                                    </h3>
                                    <p className="mt-3">
                                        Die traditionelle Ayurveda-Behandlung beginnt mit einer ausführlichen Befragung und der Pulsdiagnostik durch den Arzt. Auf dieser Grundlage lesen wir den Zustand der drei Lebensenergien in Ihrem Körper – Vata (Luft), Pitta (Feuer) und Kapha (Wasser) – und entwickeln daraus den passenden Behandlungsplan.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c]">
                                        Prakriti – Ihre angeborene, einzigartige Balance
                                    </h3>
                                    <p className="mt-3">
                                        Jeder von uns trägt von Geburt an eine eigene Konstitution und ein persönliches Energieprofil – auf Sanskrit wird dies als Prakriti bezeichnet.
                                    </p>
                                    <p className="mt-4">
                                        Alle drei Doshas sind in jedem Menschen vorhanden, aber bei vielen ist einer oder sogar zwei davon dominant. Diese Ausgewogenheit prägt die individuellen körperlichen Merkmale und die geistige Persönlichkeit.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c]">
                                        Die Rolle und Balance der Doshas
                                    </h3>
                                    <p className="mt-3">
                                        Im Sanskrit bedeutet Dosha sinngemäß „was nicht vollkommen ist“ oder „das, was beeinflusst“. Diese Energien steuern die verschiedenen Strukturen und Funktionen des Körpers.
                                    </p>
                                    <ul className="mt-4 space-y-3 border-l-2 border-[#F28600] pl-5">
                                        <li>
                                            <strong className="font-semibold text-[#1f4d3c]">Im Gleichgewicht:</strong> Die Sinne werden geschärft, Energie, Wohlgefühl und Langlebigkeit entstehen.
                                        </li>
                                        <li>
                                            <strong className="font-semibold text-[#1f4d3c]">Bei Ungleichgewicht:</strong> Sie beeinflussen die Körpergewebe negativ und können zu Beschwerden und Krankheiten führen.
                                        </li>
                                    </ul>
                                </div>

                                <blockquote className="pt-6 font-serif text-xl leading-relaxed text-[#1f4d3c]">
                                    „Wenn die drei Elemente Vata, Pitta und Kapha im Gleichgewicht sind, erhält der Mensch gesunde Sinne, Stärke, eine strahlende Hautfarbe sowie Glück und Langlebigkeit – ein Zustand tiefen Friedens im Diesseits und im Jenseits.“
                                    <cite className="mt-4 block font-mulish text-sm not-italic text-gray-600">
                                        —— Charaka Samhita, Kapitel 8, Vers 13
                                    </cite>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout (hidden on sm, visible on lg) */
  }
                <div className="mx-auto hidden max-w-7xl items-start gap-10 lg:grid lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
                    <div className="order-1 lg:sticky lg:top-28">
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-[#f3eee7] shadow-[0_24px_70px_rgba(16,38,26,0.14)]">
                            <img
    src="/images/Hiru/kapha-pitta-vata.webp"
    alt="Die Doshas Vata, Pitta und Kapha"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/55 via-transparent to-transparent" />
                        </div>
                    </div>

                    <div className="order-2">
                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                            Verständnis der Lebensenergie
                        </p>
                        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Doshas – Die Energie, die das Leben steuert
                        </h2>

                        <div className="mt-8 space-y-8 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                    Reise mit einer persönlichen Diagnose
                                </h3>
                                <p className="mt-3">
                                    Die traditionelle Ayurveda-Behandlung beginnt mit einer ausführlichen Befragung und der Pulsdiagnostik durch den Arzt. Auf dieser Grundlage lesen wir den Zustand der drei Lebensenergien in Ihrem Körper – Vata (Luft), Pitta (Feuer) und Kapha (Wasser) – und entwickeln daraus den passenden Behandlungsplan.
                                </p>
                            </div>

                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                    Prakriti – Ihre angeborene, einzigartige Balance
                                </h3>
                                <p className="mt-3">
                                    Jeder von uns trägt von Geburt an eine eigene Konstitution und ein persönliches Energieprofil – auf Sanskrit wird dies als Prakriti bezeichnet.
                                </p>
                                <p className="mt-4">
                                    Alle drei Doshas sind in jedem Menschen vorhanden, aber bei vielen ist einer oder sogar zwei davon dominant. Diese Ausgewogenheit prägt die individuellen körperlichen Merkmale und die geistige Persönlichkeit.
                                </p>
                            </div>

                            <div>
                                <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                    Die Rolle und Balance der Doshas
                                </h3>
                                <p className="mt-3">
                                    Im Sanskrit bedeutet Dosha sinngemäß „was nicht vollkommen ist“ oder „das, was beeinflusst“. Diese Energien steuern die verschiedenen Strukturen und Funktionen des Körpers.
                                </p>
                                <ul className="mt-4 space-y-3 border-l-2 border-[#F28600] pl-5">
                                    <li>
                                        <strong className="font-semibold text-[#1f4d3c]">Im Gleichgewicht:</strong> Die Sinne werden geschärft, Energie, Wohlgefühl und Langlebigkeit entstehen.
                                    </li>
                                    <li>
                                        <strong className="font-semibold text-[#1f4d3c]">Bei Ungleichgewicht:</strong> Sie beeinflussen die Körpergewebe negativ und können zu Beschwerden und Krankheiten führen.
                                    </li>
                                </ul>
                            </div>

                            <blockquote className=" pt-6 font-serif text-xl leading-relaxed text-[#1f4d3c] sm:text-2xl">
                                „Wenn die drei Elemente Vata, Pitta und Kapha im Gleichgewicht sind, erhält der Mensch gesunde Sinne, Stärke, eine strahlende Hautfarbe sowie Glück und Langlebigkeit – ein Zustand tiefen Friedens im Diesseits und im Jenseits.“
                                <cite className="mt-4 block font-mulish text-sm not-italic text-gray-600 sm:text-base">
                                    —— Charaka Samhita, Kapitel 8, Vers 13
                                </cite>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default Doshas;
